import React, { useEffect, useRef } from "react";
import EditorJS from "@editorjs/editorjs";

import Header from "@editorjs/header";
import List from "@editorjs/list";
import Table from "@editorjs/table";
import Quote from "@editorjs/quote";
import CodeTool from "@editorjs/code";
import Paragraph from "@editorjs/paragraph";

const CommonEditor = ({ value, onChange }) => {
const editorRef = useRef(null);
const editorInstance = useRef(null);

useEffect(() => {
	// Initialize editor
	editorInstance.current = new EditorJS({
	holder: editorRef.current,
	placeholder: "Start writing here...",
	data: value || {},
	tools: {
		paragraph: {
		class: Paragraph,
		inlineToolbar: true,
		},
		header: {
		class: Header,
		inlineToolbar: true,
		config: {
			levels: [1, 2, 3, 4, 5, 6],
			defaultLevel: 2,
		},
		},
		list: {
		class: List,
		inlineToolbar: true,
		},
		table: {
		class: Table,
		inlineToolbar: true,
		config: {
			rows: 2,
			cols: 3,
		},
		},
		quote: {
		class: Quote,
		inlineToolbar: true,
		},
		code: {
		class: CodeTool,
		},
	},
	});

	return () => {
	if (editorInstance.current) {
		editorInstance.current.destroy();
	}
	};
}, []);
	console.log('value', value);

const handleSave = async () => {
	if (!editorInstance.current) return;

	const savedData = await editorInstance.current.save();
	onChange?.(savedData);
};

return (
	<div style={{ border: "1px solid #ddd", padding: 15, borderRadius: 8 }}>
	<div ref={editorRef} />

	<button
		onClick={handleSave}
		type="button"
		style={{
		marginTop: 15,
		padding: "8px 15px",
		background: "#2563eb",
		color: "#fff",
		border: "none",
		borderRadius: 5,
		cursor: "pointer",
		}}
	>
		Save
	</button>
	</div>
);
};

export default CommonEditor;